import React from 'react';
import styled from 'styled-components/native';
import { LinearGradient } from 'expo-linear-gradient';
import Colors from '../constants/Colors';

interface GradientProgressBarProps {
  progress: number;
  colors?: string[];
  type?: 'rewards' | 'default';
  containerColor?: string;
  overlay?: JSX.Element;
}

const StyledView = styled.View<{ progress: number; type?: string }>`
  flex-direction: row;
  height: 25px;
  width: ${p => p.progress + '%'};
`;

const Container = styled.View<{ type?: string; backgroundColor?: string }>`
  ${p =>
    p.type === 'rewards'
      ? `
  flex-direction: row;
  align-items: center;
  border-radius: 475px;
  padding: 3.15px;`
      : `
  width: 100%;
  height: 25px;
  border-radius: 10px;`}

  background-color: ${p =>
    p.backgroundColor ? p.backgroundColor : Colors.gradientProgressBarTrack};
`;

const OverlayView = styled.View`
  width: 100%;
  height: 100%;
  position: absolute;
`;

const GradientProgressBar: React.FC<GradientProgressBarProps> = ({
  progress,
  colors,
  type,
  overlay,
  containerColor
}) => {
  return (
    <Container type={type} backgroundColor={containerColor}>
      <StyledView progress={progress * 100} type={type}>
        <LinearGradient
          colors={
            colors || [
              Colors.gradientProgressBarProgressLight,
              Colors.gradientProgressBarProgress,
              Colors.gradientProgressBarProgressDark
            ]
          }
          style={{
            borderRadius: type === 'rewards' ? 329 : 10,
            width: '100%'
          }}
          start={{ x: 0.1, y: 0 }}
          end={{ x: 1, y: 0 }}
        ></LinearGradient>
      </StyledView>
      {overlay && <OverlayView>{overlay}</OverlayView>}
    </Container>
  );
};

export default GradientProgressBar;
